(function () {
  var HEX = { black: '#16181d', 'dark brown': '#3b2415', 'brown patina': '#7a4220', tan: '#b0702f' };
  var BUCKLE_HEX = { brass: '#b08d57', silver: '#c9cbcf', gunmetal: '#55575c', 'gold horseshoe': '#d4a83a' };
  var WIDTHS = ['30mm', '35mm', '40mm'];
  var RULES = [
    [/\bblack\b|grey|gray|charcoal/, 'black'],
    [/burgundy|wine|oxblood|ox blood|maroon|\bred\b|navy|\bblue\b|dark brown|chocolate|espresso|croc/, 'dark brown'],
    [/\btan\b|cognac|honey|camel|light brown/, 'tan'],
    [/patina|brown/, 'brown patina']
  ];
  function slug(s) { return (s || '').toLowerCase().replace(/gold horseshoe/, 'horseshoe').replace(/\s+/g, '-'); }
  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP';
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency: cur }).format(cents / 100).replace(/\.00$/, ''); } catch (e) { return (cents / 100).toFixed(0); }
  }
  function init(root) {
    if (root.dataset.lsReady) return;
    root.dataset.lsReady = '1';
    var data, fb = {};
    try { data = JSON.parse(root.querySelector('[data-ls-belt-json]').textContent); } catch (e) { return; }
    try { fb = JSON.parse(root.querySelector('[data-ls-belt-fallback]').textContent); } catch (e) {}
    var names = (data.options || []).map(function (o) { return (o.name || o).toString(); });
    var ci = names.findIndex(function (n) { return /colou?r/i.test(n); });
    var bi = names.findIndex(function (n) { return /buckle/i.test(n); });
    var si = names.findIndex(function (n) { return /size|waist|length/i.test(n); });
    var variants = data.variants || [];
    function uniq(i) { var a = []; if (i > -1) variants.forEach(function (v) { if (a.indexOf(v.options[i]) < 0) a.push(v.options[i]); }); return a; }
    var colours = uniq(ci), buckles = uniq(bi), waists = uniq(si);
    waists.sort(function (a, b) { return parseFloat(a) - parseFloat(b); });
    var shoe = root.dataset.shoe || '';
    function byName(n) { return colours.find(function (c) { return c.toLowerCase() === n; }); }
    var match = colours.find(function (c) { return shoe.indexOf(c.toLowerCase()) > -1; });
    for (var r = 0; !match && r < RULES.length; r++) { if (RULES[r][0].test(shoe)) match = byName(RULES[r][1]); }
    match = match || byName('brown patina') || colours[0] || null;
    var state = { colour: match, buckle: null, waist: null, width: 1 };
    state.buckle = buckles.find(function (b) { return /silver/i.test(b) && /black/i.test(match || ''); }) || buckles.find(function (b) { return /brass/i.test(b); }) || buckles[0] || null;
    state.waist = waists.indexOf('34') > -1 ? '34' : waists[Math.floor(waists.length / 2)];

    var q = function (s) { return root.querySelector(s); };
    var img = q('[data-ls-belt-img]'), label = q('[data-ls-belt-colour]'), note = q('[data-ls-belt-note]');
    var priceEl = q('[data-ls-belt-price]'), sw = q('[data-ls-belt-swatches]'), bk = q('[data-ls-belt-buckles]');
    var bkName = q('[data-ls-belt-buckle-name]'), waist = q('[data-ls-belt-waist]'), waistVal = q('[data-ls-belt-waist-val]');
    var width = q('[data-ls-belt-width]'), widthVal = q('[data-ls-belt-width-val]');
    var btn = q('[data-ls-belt-add]'), msg = q('[data-ls-belt-msg]');

    function current() {
      return variants.find(function (v) {
        return (ci < 0 || v.options[ci] === state.colour) && (bi < 0 || v.options[bi] === state.buckle) && (si < 0 || v.options[si] === state.waist);
      });
    }
    function render() {
      var v = current();
      if (label) label.textContent = state.colour || '';
      if (note) note.textContent = state.colour === match ? 'Matched to your shoes:' : 'Colour:';
      if (bkName) bkName.textContent = state.buckle || '';
      if (waistVal) waistVal.textContent = state.waist ? state.waist + ' in' : '';
      if (widthVal) widthVal.textContent = WIDTHS[state.width];
      var key = slug(state.colour) + '-' + slug(state.buckle);
      var src = v && v.featured_image && v.featured_image.src ? v.featured_image.src : (fb[key] || fb[slug(state.colour) + '-silver'] || fb[slug(state.colour) + '-brass'] || null);
      if (img && src && img.getAttribute('src') !== src) { img.src = src; img.alt = (state.colour || '') + ' leather belt, ' + (state.buckle || '') + ' buckle'; }
      if (priceEl && v && v.price) priceEl.textContent = money(v.price);
      [].forEach.call(sw.children, function (b) { b.setAttribute('aria-checked', b.dataset.val === state.colour ? 'true' : 'false'); });
      [].forEach.call(bk.children, function (b) { b.setAttribute('aria-checked', b.dataset.val === state.buckle ? 'true' : 'false'); });
      btn.disabled = !v && !root.hasAttribute('data-demo');
      btn.textContent = v || root.hasAttribute('data-demo') ? 'Add belt' : 'Unavailable';
    }
    function chips(box, list, hexes, key, cls) {
      list.forEach(function (val) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = cls; b.dataset.val = val;
        b.setAttribute('role', 'radio'); b.setAttribute('aria-label', val); b.title = val;
        b.style.setProperty('--sw', hexes[val.toLowerCase()] || '#888');
        if (/horseshoe/i.test(val)) b.classList.add('is-round');
        b.addEventListener('click', function () { state[key] = val; render(); });
        box.appendChild(b);
      });
      if (list.length < 2) box.closest('.ls-belt__group').hidden = true;
    }
    chips(sw, colours, HEX, 'colour', 'ls-belt__swatch');
    chips(bk, buckles, BUCKLE_HEX, 'buckle', 'ls-belt__buckle');
    if (waists.length) {
      waist.max = waists.length - 1; waist.value = Math.max(0, waists.indexOf(state.waist));
      waist.addEventListener('input', function () { state.waist = waists[+waist.value]; render(); });
    } else { waist.closest('.ls-belt__group').hidden = true; }
    width.addEventListener('input', function () { state.width = +width.value; render(); });
    render();

    btn.addEventListener('click', function () {
      if (root.hasAttribute('data-demo')) { msg.textContent = 'Preview only. Create the belt product and set its handle in Theme settings.'; return; }
      var v = current(); if (!v) return;
      btn.disabled = true;
      var fd = new FormData();
      fd.append('id', v.id);
      fd.append('quantity', '1');
      fd.append('properties[Width]', WIDTHS[state.width]);
      var drawer = document.querySelector('cart-drawer');
      if (drawer) { fd.append('sections', 'cart-drawer,cart-icon-bubble'); fd.append('sections_url', window.location.pathname); }
      fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
        method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }
      }).then(function (r) { return r.json(); }).then(function (res) {
        btn.disabled = false;
        if (res.status) { msg.textContent = res.description || 'Could not add the belt. Please try again.'; return; }
        if (drawer && typeof drawer.renderContents === 'function' && res.sections) { drawer.classList.remove('is-empty'); drawer.renderContents(res); }
        else { window.location.href = (window.routes && window.routes.cart_url) || '/cart'; }
      }).catch(function () { btn.disabled = false; msg.textContent = 'Could not add the belt. Please try again.'; });
    });
  }
  function scan() { document.querySelectorAll('[data-ls-belt]').forEach(init); }
  scan();
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
})();
